import {formBuilderPickFieldById} from '@s-ui/react-form-builder'

const getNextFieldValue = ({fields, nextFieldId}) => {
  const fieldChangedIndex = fields.findIndex(carDataField => carDataField.id === nextFieldId)

  const nextFieldIndex = fieldChangedIndex + 1

  const nextDatalist = fields[nextFieldIndex]?.datalist

  if (nextDatalist?.length === 1) {
    return {
      [fields[nextFieldIndex].id]: nextDatalist[0].value
    }
  }
}

const getFieldDataById = ({formFields, fieldId}) => {
  const {context, datalist, value} = formBuilderPickFieldById(formFields, fieldId)
  const valueName = datalist && datalist.find(datalistItem => datalistItem.value === value)
  const valueText = valueName ? valueName.text : ''

  return {context, value, valueText}
}

const getRequestInterceptorHandler = ({fieldID: currentFieldId, fields, remotes, useCase}) => {
  const nextParams = {
    nextField: null,
    params: {}
  }

  remotes.forEach((fieldId, index) => {
    const {context, value} = getFieldDataById({formFields: fields, fieldId})

    const currentIndex = remotes.indexOf(currentFieldId)

    if (fieldId === currentFieldId) {
      nextParams.nextField = context
      // Verify current index to only send params for fields that come before the changed field.
    } else if (value && index < currentIndex) {
      nextParams.params[fieldId] = value
    }
  })

  return useCase.execute({
    nextField: nextParams.nextField,
    params: nextParams.params
  })
}

const isValidForm = errors => !Object.values(errors).some(error => error.length > 0)

const getClearedNumericValue = ({value}) => value?.replace(/\D/g, '')

export {getClearedNumericValue, getFieldDataById, getNextFieldValue, getRequestInterceptorHandler, isValidForm}
